import { apiClient } from "./core/client";

export interface DashboardStats {
  revenueToday: number;
  revenueYesterday: number;
  revenueMonth: number;
  revenueLastMonth: number;
  customersCount: number;
  customersThisMonth: number;
  customersLastMonth: number;
  vehiclesCount: number;
  pendingInvoices: number;
  activeJobs: number;
  todayAppointments: number;
}

export async function getDashboardStats(): Promise<DashboardStats> {
  const { data } = await apiClient.get("/api/dashboard/stats");
  return data;
}
